const initialState = {
    customerList: null,
    organizationList: null,
    domainList: null,
    scanHistoryList: null,
    downloadExcelReport: null,
    downloadpdfReport: null,
    downloadThirdPartyPdfReport: null
};
  
export default function reportsReducer(state = initialState, action) {
    switch (action.type) {
        case 'REPORTS_CUSTOMER_LIST_SUCCESS' :
            return {
                ...state,
                customerList: action.payload
            }
        case 'REPORTS_ORGANIZATION_LIST_SUCCESS': 
            return {
                ...state,
                organizationList: action.payload
            }
        case 'REPORTS_DOMAIN_LIST_SUCCESS':
            return {
                ...state,
                domainList: action.payload
            }
        case 'REPORTS_SCAN_HISTORY_SUCCESS':
            return {
                ...state,
                scanHistoryList: action.payload
            }
        case 'DOWNLOAD_EXCEL_REPORT_SUCCESS':
            return {
                ...state,
                downloadExcelReport: action.payload
            }
        case 'DOWNLOAD_PDF_REPORT_SUCCESS':
            return {
                ...state,
                downloadpdfReport: action.payload
            }
        case 'DOWNLOAD_THIRD_PARTY_PDF_REPORT_SUCCESS':
            return {
                ...state,
                downloadThirdPartyPdfReport: action.payload
            }
        case 'RESET_DOWNLOAD_DATA':
            return {
                ...state,
                downloadExcelReport: null,
                downloadpdfReport: null,
                downloadThirdPartyPdfReport: null
            }
        default:
            return state;
    }
}